import store from "@/store";
import EventService from "@/services/Event";
import Message from "@/domain/metrics/message";

export default [
    {
        path: '/preview',
        name: 'preview',
        component: () => import(/* webpackChunkName: "preview" */ '../views/PreviewPage.vue'),
        props: true,
        beforeEnter: (to, from, next) => {
            // watchesandwonders replace www
            if (to.query.hasOwnProperty('ps') && to.query.ps === '2592' && location.hostname.includes('www.')) {
                location.replace(location.href.replace('www.', 'watchesandwonders.'))
            }
            // witevents
            if (to.query.hasOwnProperty('ps') && to.query.ps === '2684' && location.hostname.includes('witevents.') && location.href.includes('JAPANOR24')) {
                location.replace(location.href.replace(/JAPANOR24-[A-Z0-9-]+/, "WITJPNA24-479AA2126-CTBOUAPST"))
            }
            // campari
             if (to.query.hasOwnProperty('ps') && to.query.ps === '2620' && location.hostname.includes('camparigroup.')) {
                 location.replace(location.href.replace('camparigroup.', 'campari.').replace('2620', '2756').replace(/BARTCOM24-[A-Z0-9-]+/, "BARCO2024-2D988BF0F-JY0TH7MAM"))
            }
             // Redirect di ID 2921 Davide Campari Lounge Locarno sull'evento ID 2916 Campari Opening Party Locarno
             if (to.query.hasOwnProperty('ps') && to.query.ps === '2921') {
                 location.replace(location.href.replace(/CAMPARI77-[A-Z0-9-]+/, 'LOCARNO77-DD6291249-5ZS48KG8V').replace('2921', '2916'))
             }

            if (to.params.photos) {
                next()
                return
            }
            Message.openedCheckinPreview(to.query)

            const isAuthenticated = store.getters['auth/isAuthenticated']
            // "ep" stands for encrypted parameters
            if ((!(to.query.hasOwnProperty('ep') || to.query.hasOwnProperty('pc')) || !(to.query.hasOwnProperty('ps') || to.query.hasOwnProperty('pica_service'))) && !to.query.hasOwnProperty('picacode')) {
                if (isAuthenticated) {
                    next({name: 'checkins-list'})
                } else {
                    next({name: 'homepage'})
                }
            } else {
                return EventService.getPreviewPhotos(to.query)
                    .then(response => {
                        store.commit('SET_AUTO_CHECKIN_PICACODE', response.data.picacode)
                        store.commit('SET_IS_PREVIEW_CHECKIN', true)
                        store.commit('SET_AUTO_CHECKIN_SOURCE', response.data.source)
                        store.commit('SET_AUTO_CHECKIN_TAGS', response.data.tags)
                        store.commit('SET_AUTO_CHECKIN_SHOW_MARKETING_CHECK', to.query.ps === '2394')
                        store.commit('SET_DISABLE_SOCIAL_LOGIN_IN_PREVIEW', response.data.disable_social_login)
                        store.commit('SET_DATE_OF_STAY', {start: response.data.start_of_stay, end: response.data.end_of_stay})

                        if (to.query.hasOwnProperty('redirect')) {
                            store.commit('SET_REDIRECT_TO', to.query.redirect)
                        }
                        // store campaign data
                        const campaign_code = response.data.campaign_code
                        if (campaign_code) {
                            const campaign_expires_at = response.data.campaign_expires_at
                            const campaign = {
                                campaign_code: campaign_code,
                                campaign_expires_at: campaign_expires_at
                            }
                            const campaignToJson = JSON.stringify(campaign)

                            localStorage.setItem("campaign", campaignToJson);
                            store.commit('cartDigitalItems/setCampaign', campaignToJson)
                        }

                        if (to.query.hasOwnProperty('accessToken')) {
                            // IBI AUTH
                            var trackingDenied = window.__GETPICA__ && window.__GETPICA__.tracking.denied;
                            if (window.cookiehub && !trackingDenied) {
                                window.cookiehub.allowAll();
                                window.cookiehub.closeDialog();
                            }

                            const appEnv = 'webview'
                            localStorage.setItem("app_env", appEnv);
                            store.commit('appConfig/SET_APP_ENV', appEnv)

                            store.dispatch("auth/ibiLogin", {'access_token': to.query.accessToken}).then(() => {
                                next({name: 'checkins-list'})
                            }).catch(() => {
                                next({name: 'homepage'})
                            })
                        }

                        // SSO auto-login: the backend returns auth data inline
                        // in the `auth` field (sso_url is deprecated)
                        if (response.data.auth && response.data.auth.type === 'sso') {
                            store.dispatch('auth/ssoLogin', {
                                integration_id: response.data.auth.integration_id,
                                token: response.data.auth.token,
                            }).then(() => {
                                return store.dispatch('auth/getCurrentUser')
                            }).then(() => {
                                if (store.getters['auth/hasAcceptedRequiredPolicies']) {
                                    next({name: 'checkins-list'})
                                } else {
                                    next({name: 'terms', params: {next: 'checkins-list'}})
                                }
                            }).catch(() => {
                                next({name: 'homepage'})
                            })
                            return
                        }

                        if (isAuthenticated) {
                            next({name: 'checkins-list'})
                            return
                        }

                        next({
                            name: 'preview',
                            params: {
                                photos: response.data.photos,
                                event_name: response.data.event_name,
                                experience_type: response.data.experience_type
                            },
                            query: to.query
                        })

                    })
                    .catch((error) => {
                       next({
                          name: 'checkin-error',
                          params: { error }
                        })
                    })
            }
        },
    },
]

